export const TABLE = {
  QUESTION_PICTURES: 'question_pictures',
  POSTIT_PICTURES: 'postit_pictures',
};